import React from 'react';
import Modal from './modal';
import ModalManager from './ModalManager';

export default class ModalContainer extends React.Component {
  state = {
    title: "",
    message: "",
    buttonName: "",
    onClick: () => {},
    active: false,
    BodyComponent: () => null,
    noCancel: false,
    noSubmit: false,
    preventOutsideClose: false,
    modalStyle: null,
    contentStyle: null,
  }

  componentWillMount = () => {
    ModalManager.addChangeListener(this.handleStoreChange);
  };

  componentWillUnmount = () => {
    ModalManager.removeChangeListener(this.handleStoreChange);
  };

  handleStoreChange = ({
    title,
    message,
    buttonName,
    BodyComponent,
    onClick,
    noCancel,
    noSubmit,
    preventOutsideClose,
    modalStyle,
    contentStyle,
  }) => {
    this.setState({
      title,
      message,
      buttonName,
      onClick,
      BodyComponent,
      active: true,
      noCancel: noCancel,
      noSubmit: noSubmit,
      preventOutsideClose: preventOutsideClose,
      modalStyle: modalStyle,
      contentStyle: contentStyle,
    });
  };

  changeModalContainerState = newState => this.setState(newState)

  render() {
    const {
      title,
      message,
      buttonName,
      onClick,
      active,
      BodyComponent,
      noSubmit,
      noCancel,
      preventOutsideClose,
      modalStyle,
      contentStyle,
    } = this.state;

    if (!active) return null;

    return (
      <Modal
        title={title}
        message={message}
        buttonName={buttonName}
        onClick={onClick}
        active={active}
        BodyComponent={BodyComponent}
        changeModalContainerState={this.changeModalContainerState}
        noSubmit={noSubmit}
        noCancel={noCancel}
        preventOutsideClose={preventOutsideClose}
        modalStyle={modalStyle}
        contentStyle={contentStyle}
      />
    );
  }
}